var exports = {
  "Qs": "ThemeAcceptModal.module__content___TVhqVH",
  "h_": "ThemeAcceptModal.module__description___TVhqVH",
  "Hy": "ThemeAcceptModal.module__codeContainer___TVhqVH",
  "AS": "ThemeAcceptModal.module__pre___TVhqVH",
  "Y4": "ThemeAcceptModal.module__hljs___TVhqVH",
  "lB": "ThemeAcceptModal.module__codeActions___TVhqVH",
  "vo": "ThemeAcceptModal.module__codeActionsVisible___TVhqVH",
  "cL": "ThemeAcceptModal.module__copyButton___TVhqVH",
  "nJ": "ThemeAcceptModal.module__copyIcon___TVhqVH",
  "KQ": "ThemeAcceptModal.module__loadingText___TVhqVH",
  "kc": "ThemeAcceptModal.module__errorText___TVhqVH",
  "qr": "ThemeAcceptModal.module__footer___TVhqVH",
};

module.exports = exports;
